module.exports = __webpack_public_path__ + "static/media/productos_botanas_habaenchilada.f571f5f2.jpg";